import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AmplifyComponent } from './components/Amplify/amplify.component';
import { WireService } from '../Wire/services/wire.service';
import { CoreModule } from '../../Core/core.module';
import { LayoutModule } from '../../Common/Layout/layout.module';
import { CoreDialogsModule } from '../../Core/Dialogs/dialogs.module';
import { AmplifyRoutingService } from './services/amplify-routing.service';
import { CommonFormsModule } from '../../Common/Forms/forms.module';
import { WireRouteGuard } from './services/wire-route-guard';
import { EditorRouteGuard } from './services/editor-route-guard';
import { AmplifyLeftSidebarService } from './services/amplify-left-sidebar.service';

@NgModule({
    imports: [
        CoreModule,
        CommonFormsModule,
        LayoutModule,
        CoreDialogsModule,
        CommonModule
    ],
    exports: [
        AmplifyComponent
    ],
    declarations: [
        AmplifyComponent
    ],
    providers: [
        WireService,
        /* Amplify Services */
        AmplifyRoutingService,
        WireRouteGuard,
        EditorRouteGuard,
        AmplifyLeftSidebarService
    ]
})
export class AmplifyCoreModule { }
